import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OneFieldDialogComponent } from 'src/app/dialogs/onefield-dialog/onefield-dialog.component';
import { ValidateDialogComponent } from 'src/app/dialogs/validate-dialog/validate-dialog.component';
import { CNServiceCode } from 'src/app/models/cnservicecode';
import { CNServiceCodeCustom } from 'src/app/models/cnservicecodecustom';
import { CNServiceCodeINAMIValue } from 'src/app/models/cnservicecodeinamivalue';
import { ServicesService } from 'src/app/services/services.service';

@Component({
  selector: 'app-admin-service-code-value',
  templateUrl: './admin-service-code-value.component.html',
  styleUrls: ['./admin-service-code-value.component.scss']
})
export class AdminServiceCodeValueComponent implements OnInit {

  @Input() value: CNServiceCodeINAMIValue;
  @Input() code: CNServiceCodeCustom;

  constructor(private services: ServicesService, private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  saveValue(): void {
    if (this.code) {
      if (this.code.id === 0) {
        // new code
        this.services.addCode(this.code).subscribe(newCode => {
          this.code = newCode;
        }, error => {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.data = {
            title: 'Erreur lors de la création du code',
            message: error,
            ok: {
              label: 'OK',
              code: 'ok'
            }
          };
          this.dialog.open(ValidateDialogComponent, dialogConfig);
        });
      } else {
        this.services.updateCode(this.code).subscribe(updatedCode => {
          this.code = updatedCode;
        }, error => {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.data = {
            title: 'Erreur lors de la mise à jour du code',
            message: error,
            ok: {
              label: 'OK',
              code: 'ok'
            }
          };
          this.dialog.open(ValidateDialogComponent, dialogConfig);
        });
      }
    }
    if (this.value) {
      this.services.updateValue(this.value).subscribe(updatedValue => {
        this.value = updatedValue;
      }, error => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
          title: 'Erreur lors de la mise à jour du code',
          message: error,
          ok: {
            label: 'OK',
            code: 'ok'
          }
        };
        this.dialog.open(ValidateDialogComponent, dialogConfig);
      });
    }
  }

  removeValue(): void {

  }

}
